import React from 'react';
import LoudSpeaker from '../../components/Icon/custom/LoudSpeaker';
import Home from '../../components/Icon/custom/Home';
import Bulletin from '../../components/Icon/custom/Bulletin';
import BrainBank from '../../components/Icon/custom/BrainBank';
import Ideasphere from '../../components/Icon/custom/Ideasphere';
import Settings from '../../components/Icon/custom/Settings';
// import Plan from '../../components/Icon/custom/Plan';
import Forum from '@material-ui/icons/ForumTwoTone';
import Team from '../../components/Icon/custom/Team';
import Profile from '@material-ui/icons/PersonOutline';
import Signal from '@material-ui/icons/SignalCellularAltOutlined';

export const PAGE_KEYS = {
  WAB: 'wab',
  SHOP_TALK: 'shop-talk'
};

const pages = [
  { key: 'home', label: 'Home', path: '/', icon: <Home /> },
  { key: 'promotions', label: 'Promotions', path: '/promotions', icon: <LoudSpeaker /> },
  { key: PAGE_KEYS.WAB, label: 'WAB', path: '/wab', icon: <Bulletin /> },
  // {
  //   key: 'plan',
  //   label: 'My Plan',
  //   path: '/plan',
  //   icon: <Plan />,
  //   allowedGroups: ['Management', 'Members']
  // },
  { key: 'brain-bank', label: 'Brain Bank', path: '/brain-bank', icon: <BrainBank /> },
  {
    key: PAGE_KEYS.SHOP_TALK,
    label: 'Shop Talk',
    path: '/shop-talk',
    icon: <Forum />,
    allowedGroups: ['Management', 'Members']
  },
  {
    key: 'my-results',
    label: 'Results',
    path: '/my-results',
    icon: <Signal />,
    allowedGroups: ['Management', 'Members']
  },
  {
    key: 'my-team',
    label: 'My Team',
    path: '/my-team',
    icon: <Team />,
    allowedGroups: ['Admins', 'Management']
  },
  { key: 'youpreneur', label: 'Youpreneur', path: '/youpreneur', icon: <Ideasphere /> },
  {
    key: 'settings',
    label: 'Settings',
    path: '/settings',
    icon: <Settings />,
    allowedGroups: ['Admins', 'Management']
  },
  {
    key: 'profile',
    label: 'Profile',
    path: '/profile',
    icon: <Profile />,
    allowedGroups: ['Members']
  }
];
export default pages;
